import PVSActivitiesRouter from './pvs_activities/router';
import SurveyActivitiesRouter from './survey_activities/router'

export default {
    common: [],
    0: [],
    1: [],
    3: [
        ...PVSActivitiesRouter[3],
        ...SurveyActivitiesRouter[3]
    ],
    4: [
        ...PVSActivitiesRouter[4],
    ],
    5: [
        ...PVSActivitiesRouter[5],
    ],
    6: [],
    7: [],
    8: [],
    9: [],
    10: [],
    11: [],
    12: [],
    13: [],
    14: [
        ...PVSActivitiesRouter[21]
    ],
    15: [],
    16: [],
    17: [],
    18: [],
    19: [],
    20: [],
    21: [
        ...PVSActivitiesRouter[21]
    ],
};